import { GeneratingVideoPoster } from '../components/AssetMedia'
import { FailedMediaStatusOverlay } from '../components/GeneratingStatusText'
import { FAILED_REEL_MESSAGE } from './preview-utils'

interface FeedPreviewReelFallbackProps {
  posterUrl?: string | null
  isFailedReel: boolean
  isGeneratingVideo: boolean
  className?: string
}

/** Failed or in-flight reel on feed-style previews (poster + status chrome). */
export function FeedPreviewReelFallback({
  posterUrl,
  isFailedReel,
  isGeneratingVideo,
  className = 'h-full w-full',
}: FeedPreviewReelFallbackProps) {
  if (isFailedReel) {
    return (
      <FailedMediaStatusOverlay
        className={className}
        posterUrl={posterUrl ?? undefined}
        message={FAILED_REEL_MESSAGE}
        tone="light"
      />
    )
  }
  if (isGeneratingVideo && posterUrl) {
    return <GeneratingVideoPoster imageUrl={posterUrl} tone="light" className={className} />
  }
  return null
}
